<template>
  <div>

    <modal-component
      v-if="edit"
      v-model="modal.editContact.active"
    >
      <div slot="title">{{ modal.editContact.title }}</div>
      <edit-contact
        :contactID="editContactID"
        :manual-contact-type="contactType"
        :create-alert="false"
        @updated="closeEditContactModal"
      ></edit-contact>
    </modal-component>

    <router-link v-if="linkToContact" :to="'/' + contactType + '/details/' + contact.id">
      <p class="text-xs">#{{ contact.id }}</p>
      <p class="text-2xl font-bold text-link">
        {{ contact.first_name }} {{ contact.last_name }}
        <sup class="font-normal text-xs ml-1">
          <i class="fas fa-link"></i>
        </sup>
      </p>
      <p class="font-bold" v-if="contact.company_name">{{ contact.company_name }}</p>
    </router-link>
    <template v-else>
      <p class="text-xs">#{{ contact.id }}</p>
      <p class="text-2xl font-bold text-link">{{ contact.first_name }} {{ contact.last_name }}</p>
      <p class="font-bold" v-if="contact.company_name">{{ contact.company_name }}</p>
    </template>

    <div class="mt-4">
      <p class="font-bold text-lg">EMAIL:</p>
      <p>{{ contact.email }}</p>
    </div>

    <div class="mt-4">
      <p class="font-bold text-lg">PHONE NUMBERS:</p>
      <div
        class="py-2 px-4 bg-theme-300 text-theme-lighter border border-theme-200 light:border-theme-600 light:bg-theme-100 rounded mb-2 leading-tight"
        v-for="(phone, i) in phoneNumbers"
        :key="'phone-' + i"
      >
        <div v-if="phone.countryData">
          <p class="text-sm">{{ phone.description }}</p>
          <p class="text-xl font-bold">
            <span :title="phone.countryData.name">{{ '+' + phone.countryData.calling_code }}</span> {{ phone.number }}
          </p>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <p class="font-bold text-lg">ADDRESSES:</p>
      <div
        class="py-2 px-4 bg-theme-300 text-theme-lighter border border-theme-200 light:border-theme-600 light:bg-theme-100 rounded mb-2 leading-tight"
        v-for="(addr, i) in contact.addresses"
        :key="'address-' + i"
      >
        <address>
          {{ addr.address_1 }},<br>
          {{ addr.city }},
          <span v-if="addr.state">{{ addr.state }}, </span>
          <span>{{ addr.post_code }}</span>,<br>
          <span>{{ CountryByID(addr.country_id).name }}</span>
        </address>
      </div>
    </div>

    <div class="text-center mt-8">
      <button
        v-if="edit && hasPermission(contactType + '.edit')"
        type="button"
        class="btn btn-blue py-2 px-3"
        @click="editContact"
      >
        <i class="fas fa-edit"></i>
        <span class="ml-2">Edit {{ contactType }}</span>
      </button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const EditContact = resolve => require(['@/components/pages/contacts/Edit'], resolve)
const ModalComponent = resolve => require(['@/components/Modal'], resolve)

export default {
  name: 'contact-information',
  props: {
    contact: Object,
    contactType: {
      type: String,
      default: 'customer',
    },
    linkToContact: Boolean,
    edit: Boolean,
  },
  components: {
    EditContact,
    ModalComponent,
  },
  computed: {
    phoneNumbers() {
      return this.contact.phone_numbers.map(pn => {
        pn.countryData = this.CountryByID(pn.country_id)
        return pn
      })
    },
    contactName() {
      return this.contact.first_name + ' ' + this.contact.last_name + (this.contact.company_name ? ' (' + this.contact.company_name + ')' : '')
    },
    ...mapGetters({
      CountryByID: 'countries/countryByID',
      config: 'config/config',
      hasPermission: 'user/hasPermission',
    })
  },
  data() {
    return {
      editContactID: null,
      modal: {
        editContact: {
          active: false,
          title: '',
        },
      },
    }
  },
  methods: {
    editContact() {
      this.editContactID = this.contact.id
      // show modal
      this.modal.editContact.title = 'Edit ' + this.contactType
      this.modal.editContact.active = true
    },
    closeEditContactModal(contact) {
      // cheap way to deal with bubbles
      if (!this.edit) {
        return
      }
      // show alert
      this.$swal.fire({
        title: 'Done',
        text: this.contactType + ' edited successfully!',
        type: 'success',
      })

      // close modal
      this.modal.editContact.active = false

      // emit to parent
      this.$emit('updated', contact)
    },
  }
}
</script>
